import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApproveListComponent } from './approvelist.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [ApproveListComponent],
  exports: [
    ApproveListComponent
  ],
  providers: [
  ]
})
export class ApproveListModule { }
